import {Steps} from 'shared/tools';

const STEPS = [
  {
    name: 'time_tracking.manage.schedules.edit.steps.Schedule Details',
    location: 'schedule_details'
  },
  {
    name: 'time_tracking.manage.schedules.edit.steps.Employees',
    location: 'employees'
  },
  {
    name: 'time_tracking.manage.schedules.edit.steps.Review',
    location: 'review'
  }
].map((s, i) => ({
  ...s,
  index: i + 1
}));

const singleton = new Steps(STEPS);

export default singleton;
